import { memo } from "react"

const DebtControl = () => {
  return (
    <>
      Quản lý công nợ
    </>
  )
}

export default memo(DebtControl)